import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "remove-all-input-styling" }

import { onMounted, reactive, ref, watch } from 'vue';
import { useCodeStore } from '@/services/useCodeStore';


export default /*@__PURE__*/_defineComponent({
  __name: 'ExpenseCodePicker',
  props: {
  modelValue: {
    type: Object,
    required: false,
    default: () => ({ id: '', label: '' }),
  },
  disabled: {
    type: Boolean,
    default: false,
  },
},
  emits: ['update:modelValue', 'codeChange'],
  setup(__props, { emit: __emit }) {

const codeStore = useCodeStore();
const emit = __emit;

const props = __props;

const expenseRef = ref(null);
const selectedCode = ref(props.modelValue);

const expenseState = reactive({
  loading: false,
  expenseCodes: [],
});

onMounted(async () => {
  try {
    expenseState.loading = true;
    expenseState.expenseCodes = await codeStore.expenseCodes();
    populateSelected();
  } catch (error) {
    console.error(error);
  } finally {
    expenseState.loading = false;
  }
});

const populateSelected = () => {
  if (props.modelValue?.id) {
    selectedCode.value =
      expenseState.expenseCodes.find((e) => e.id === props.modelValue.id) ||
      props.modelValue;
  } else {
    selectedCode.value = { id: '', label: '' };
  }
};

const handleCodeChange = (value) => {
  selectedCode.value = value;
  emit('update:modelValue', value);
  emit('codeChange', value);
};

watch(
  () => props.modelValue,
  () => {
    populateSelected();
  },
);

return (_ctx: any,_cache: any) => {
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("label", { class: "text-sm at-choose-client remove-outline" }, "Expense Code", -1)),
    _createVNode(_component_v_autocomplete, {
      ref_key: "expenseRef",
      ref: expenseRef,
      "data-cy": "expense-code-dropdown",
      modelValue: selectedCode.value,
      "onUpdate:modelValue": [
        _cache[0] || (_cache[0] = ($event: any) => ((selectedCode).value = $event)),
        handleCodeChange
      ],
      items: expenseState.expenseCodes,
      loading: expenseState.loading,
      "item-title": "label",
      "item-value": "id",
      "return-object": "",
      clearable: "",
      density: "compact",
      variant: "outlined",
      class: "remove-outline",
      placeholder: "Expense Code",
      "hide-details": "true",
      "item-props": (item) => ({ disabled: item.disabled }),
      "menu-props": { maxWidth: expenseRef.value?.$el?.offsetWidth },
      disabled: __props.disabled
    }, null, 8, ["modelValue", "items", "loading", "item-props", "menu-props", "disabled"])
  ]))
}
}

})